import DoctorVisits from '../sections/doctorVisits/doctorVisits';

export default function DoctorVisitsPage() {
  return (
    <div className="section-page">
      <DoctorVisits />
    </div>
  );
}
